import axios from 'axios';
import { API_BASE_URL } from '@config';

export const SET_WALKTHROUGH_ACTIVE = 'SET_WALKTHROUGH_ACTIVE';
export const SET_WALKTHROUGH_STEP = 'SET_WALKTHROUGH_STEP';
export const SET_WALKTHROUGH_CONFIG = 'SET_WALKTHROUGH_CONFIG';
export const SET_WALKTHROUGH_COMPLETED = 'SET_WALKTHROUGH_COMPLETED';
export const SET_WALKTHROUGH_ENABLED = 'SET_WALKTHROUGH_ENABLED';
export const RESET_WALKTHROUGH = 'RESET_WALKTHROUGH';

/**
 * Start the walkthrough
 */
export function startWalkthrough() {
    return { type: SET_WALKTHROUGH_ACTIVE, payload: true };
}

/**
 * Stop/dismiss the walkthrough
 */
export function stopWalkthrough() {
    return { type: SET_WALKTHROUGH_ACTIVE, payload: false };
}

/**
 * Set the current step index
 */
export function setWalkthroughStep(step) {
    return { type: SET_WALKTHROUGH_STEP, payload: step };
}

/**
 * Mark walkthrough as completed for the current user
 */
export function completeWalkthrough() {
    return function (dispatch) {
        // Persist to localStorage immediately
        localStorage.setItem('walkthrough_completed', 'true');

        dispatch({ type: SET_WALKTHROUGH_COMPLETED, payload: true });
        dispatch({ type: SET_WALKTHROUGH_ACTIVE, payload: false });

        // Also persist to server so it sticks across browsers
        axios.put(API_BASE_URL + '/api/users/walkthrough-completed').catch(function () {
            // Non-critical - localStorage is the primary store
        });
    };
}

/**
 * Check if walkthrough is enabled for the user's organization
 * and if the user has already completed it
 */
export function checkWalkthroughStatus() {
    return function (dispatch) {
        // Check localStorage first
        var completed = localStorage.getItem('walkthrough_completed') === 'true';
        if (completed) {
            dispatch({ type: SET_WALKTHROUGH_COMPLETED, payload: true });
        }

        // Check org-level setting from the API
        axios.get(API_BASE_URL + '/api/organizations/walkthrough-enabled')
            .then(function (res) {
                dispatch({
                    type: SET_WALKTHROUGH_ENABLED,
                    payload: res.data.walkthroughEnabled || false
                });

                // Also check server-side completion status
                if (res.data.userWalkthroughCompleted) {
                    localStorage.setItem('walkthrough_completed', 'true');
                    dispatch({ type: SET_WALKTHROUGH_COMPLETED, payload: true });
                }
            })
            .catch(function () {
                // If endpoint doesn't exist yet, default to disabled
                dispatch({ type: SET_WALKTHROUGH_ENABLED, payload: false });
            });
    };
}

/**
 * Toggle walkthrough enabled for the organization (admin action)
 */
export function setOrgWalkthroughEnabled(enabled) {
    return function (dispatch) {
        dispatch({ type: SET_WALKTHROUGH_ENABLED, payload: enabled });

        return axios.put(API_BASE_URL + '/api/organizations/walkthrough-enabled', {
            walkthroughEnabled: enabled
        });
    };
}

/**
 * Reset walkthrough for the current user (allow re-play)
 */
export function resetWalkthroughForUser() {
    return function (dispatch) {
        localStorage.removeItem('walkthrough_completed');
        dispatch({ type: SET_WALKTHROUGH_COMPLETED, payload: false });
        dispatch({ type: SET_WALKTHROUGH_STEP, payload: 0 });

        axios.put(API_BASE_URL + '/api/users/walkthrough-completed', {
            completed: false
        }).catch(function () {});
    };
}
